import React from 'react';

const ContextDetails = React.createContext();
export default ContextDetails;